export default "__VITE_ASSET__DyNrPcwi__"